/**
 * @param unsafeDomain string to be checked
 * @returns boolean
 * @description
 * Valid -> www.talentmesh.com
 *
 * Invalid -> http://talentmesh.com
 */
export const isValidDomainUrl = (unsafeDomain: string) => {
    try {
        // The URL constructor requires a full URL (including a base or protocol).
        // We can prepend 'https://' to see if the string functions as a valid hostname.
        const url = new URL(`https://${unsafeDomain}`);

        // Check if the resulting URL's hostname matches the original string
        // (after removing 'www.' if present) and has no path other than '/'.
        const hostname = url.hostname.replace(/^www\./, '');
        const hasNoPath = url.pathname === '/' || url.pathname === '';

        return hostname === unsafeDomain.replace(/^www\./, '') && hasNoPath;
    } catch (e) {
        // If the constructor throws a TypeError, the input is not a valid structure.
        return false;
    }
};

export const isValidCompanyName = (unsafeCompanyName: string) => {
    return !!unsafeCompanyName.trim();
};
